import 'bootstrap/dist/css/bootstrap.min.css';
import '../HomePage.css'
import { Button } from 'react-bootstrap';

const DynamicBtn = ({ value, selected, onClick, amount }) => {
    const handleClick = (e) => {
        // Stop propagation so parent row arrow handlers don't receive it
        e.stopPropagation();
        if (onClick) onClick(value, e);
    };

    return (
        <Button
          className={`dynamic-btn ${selected ? "selected-btn" : ""}`}
          variant={selected ? 'outline-warning' : 'transparent'}
          style={{ padding: 0, position: 'relative', display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%' }}
          onClick={handleClick}
        >
          {/* Number on the left (large). Amount on the right (compact) */}
          <span className={`btn-value ${amount ? '' : 'text-white'}`}>{value}</span>

          {amount !== undefined && amount !== '' && amount !== null ? (
            <span className="amount-right" aria-hidden>
              {amount}
            </span>
          ) : null}
        </Button>
    );
};

export default DynamicBtn;
